/**
 * DeleteUserConfirm
 *
 * Extracted from `UsersTab.tsx` to keep the parent under the 300-line cap
 * once the Phase-6 "Manage sub-delegates" flow was wired in.
 */

import type { AdminUser } from '../types/admin-user.type';

type DeleteUserConfirmProps = {
  user: AdminUser;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeleteUserConfirm({
  user,
  isPending,
  onCancel,
  onConfirm,
}: DeleteUserConfirmProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-user-title"
        className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6"
      >
        <h3 id="delete-user-title" className="text-lg font-semibold text-gray-900 mb-2">
          Delete User
        </h3>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete{' '}
          <span className="font-medium">
            {user.firstName} {user.lastName || ''}
          </span>
          ? This action will soft-delete the user and they will no longer appear
          in lists.
        </p>
        <div className="flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isPending}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isPending}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center gap-2"
          >
            {isPending ? (
              <>
                <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Deleting...</span>
              </>
            ) : (
              <span>Delete User</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
